import { Amplify } from "aws-amplify";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { config } from "./config";
import "./lib/map/setup";
import "./styles/globals.css";

// for joblog graphql
Amplify.configure({
  API: {
    GraphQL: {
      endpoint: config.appsync.graphqlEndpoint,
      region: "ap-northeast-1",
      defaultAuthMode: "apiKey",
      apiKey: config.appsync.apiKey,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
